import { render, staticRenderFns } from "./communityRecommend.vue?vue&type=template&id=84f7028a&scoped=true"
import script from "./communityRecommend.vue?vue&type=script&lang=js"
export * from "./communityRecommend.vue?vue&type=script&lang=js"
import style0 from "./communityRecommend.vue?vue&type=style&index=0&id=84f7028a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f7028a",
  null
  
)

export default component.exports